<h1 mat-dialog-title>{{ 'labels.heading.Upload Client Signature' | translate }}</h1>

<div>
  <LOSx-file-upload flex="60%" (change)="onFileSelect($event)" acceptFilter=".png,.jpeg,.jpg"></LOSx-file-upload>

  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
    <button mat-raised-button color="primary" [disabled]="!signature" [mat-dialog-close]="signature">
      {{ 'labels.buttons.Confirm' | translate }}
    </button>
  </mat-dialog-actions>
</div>
